module.exports = __webpack_public_path__ + "static/img/thank.55c302ea.png";